module.exports = __webpack_public_path__ + "img/banner4.44584afb.svg";